import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { theme } from './config/theme';
import { AuthProvider } from './context/AuthContext';
import { AnalysisProvider } from './context/AnalysisContext';
import { AuthGuard } from './components/auth/AuthGuard';
import { AuthCallback } from './components/auth/AuthCallback';
import { MainLayout } from './components/layout/MainLayout';
import { HomePage } from './pages/HomePage';
import { UploadPage } from './pages/UploadPage';
import { DecksListPage } from './pages/DecksListPage';
import { AnalysisDashboard } from './pages/AnalysisDashboard';
import { SlideDetailPage } from './pages/SlideDetailPage';
import { ChatPage } from './pages/ChatPage';
import { IssueBrowserPage } from './pages/IssueBrowserPage';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <AnalysisProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<MainLayout />}>
                <Route index element={<HomePage />} />
              </Route>

              {/* Auth Callback */}
              <Route path="/auth/callback" element={<AuthCallback />} />

              {/* Protected Routes */}
              <Route
                path="/"
                element={
                  <AuthGuard>
                    <MainLayout />
                  </AuthGuard>
                }
              >
                <Route path="upload" element={<UploadPage />} />
                <Route path="decks" element={<DecksListPage />} />
                <Route path="analysis/:deckId" element={<AnalysisDashboard />} />
                <Route path="analysis/:deckId/slide/:slideNumber" element={<SlideDetailPage />} />
                <Route path="analysis/:deckId/issues" element={<IssueBrowserPage />} />
                {/* Back-compat: redirect old path segment to query param */}
                <Route
                  path="analysis/:deckId/issues/:severity"
                  element={<Navigate to="../issues" replace />}
                />
                <Route path="chat/:deckId" element={<ChatPage />} />
              </Route>
            </Routes>
          </AnalysisProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;

